module.exports = __webpack_public_path__ + "static/media/active-01.1f2e2abb.svg";